<template>
  <div>
    <div>
      <h2 class="text-[20px] font-medium leading-[26px] text-gray-800 mb-5">
        Default privacy<br />for registered work
      </h2>

      <div
        class="flex items-start gap-3 rounded-[14px] bg-[#D4D8E1]/20 px-[14px] py-4"
      >
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-1.5">
            <LockIcon class="size-[18px] text-gray-800" />
            <span class="text-[14px] font-medium leading-[18px] text-gray-800">
              Private by default
            </span>
          </div>
          <p class="mt-1.5 text-[14px] leading-[20px] text-gray-600">
            Only you and people you invite can view the work and its
            description.
          </p>
        </div>
        <Toggle
          :model-value="modelValue"
          :size="toggleSize"
          class="mt-0.5 shrink-0"
          @update:model-value="emit('update:modelValue', $event)"
        />
      </div>

      <p class="mt-3 text-[15px] leading-[18px] text-gray-600">
        Change anytime in settings.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Toggle } from '@dacr/library'
import { LockIcon } from '@dacr/icons'
import { useDevice } from '@/shared/composables/useDevice'

defineProps<{
  modelValue: boolean
}>()
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()

const { isDesktopLayout } = useDevice()
const toggleSize = computed(() => (isDesktopLayout.value ? 'md' : 'lg'))
</script>
